import { render, staticRenderFns } from "./IndexProductBody.vue?vue&type=template&id=41e5ad9e&scoped=true&"
import script from "./IndexProductBody.vue?vue&type=script&lang=js&"
export * from "./IndexProductBody.vue?vue&type=script&lang=js&"
import style0 from "./IndexProductBody.vue?vue&type=style&index=0&id=41e5ad9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e5ad9e",
  null
  
)

export default component.exports